export const EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const JSON = 'application/json';
export const PDF = 'application/pdf';
export const CSV = 'text/csv';